export enum NotificationSubTypeName {
  EnableMini = 'EnableMini',
  EnableMiniDefault = 'EnableMiniDefault',
  EnableMiniMandatory = 'EnableMiniMandatory',
  EnableDelayed = 'EnableDelayed',
  EnableDelayedDefault = 'EnableDelayedDefault',
  EnableDelayedMandatory = 'EnableDelayedMandatory',
}

export enum NotificationSubTypeFlagName {
  IsDefault = 'IsDefault',
  IsRequired = 'IsRequired',
  IsEnabled = 'IsEnabled',
}
